import I18n from "i18n-js";
import React from "react";

export default class SearchPagination extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.total_pages === 0) {
      return null;
    }

    var buttons = [];
    if (this.props.total_pages > 5) {
      // only print 5 pages of total pages
      if (this.props.page + 2 >= this.props.total_pages) {
        // print last 5 pages
        for (
          var i = this.props.total_pages - 4;
          i <= this.props.total_pages;
          i++
        ) {
          buttons.push(this.renderPage(i));
        }
      } else if (this.props.page >= 3) {
        // print current page in middle, with 2 before and 2 after
        for (var i = this.props.page - 2; i <= this.props.page + 2; i++) {
          buttons.push(this.renderPage(i));
        }
      } else {
        // print current page first, with 4 after
        for (var i = 1; i <= 5; i++) {
          buttons.push(this.renderPage(i));
        }
      }
    } else {
      // print all pages
      for (var i = 1; i <= this.props.total_pages; i++) {
        buttons.push(this.renderPage(i));
      }
    }

    return (
      <div className="search-pagination">
        <div
          className="search-button link back-page"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              this.props.onChangePage(this.props.page - 1, false);
            }
          }}
          role="button"
          aria-label={I18n.t("previous_page_of_search_results")}
          onClick={this.props.onChangePage.bind(
            null,
            this.props.page - 1,
            false
          )}
        >
          <div className="value">&laquo;</div>
        </div>
        {buttons}
        <div
          className="search-button link next-page"
          tabIndex={0}
          role="button"
          aria-label={I18n.t("next_page_of_search_results")}
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              this.props.onChangePage(this.props.page + 1, false);
            }
          }}
          onClick={this.props.onChangePage.bind(
            null,
            this.props.page + 1,
            false
          )}
        >
          <div className="value">&raquo;</div>
        </div>
      </div>
    );
  }

  renderPage(i) {
    return (
      <div
        className={
          "search-button link " + (i === this.props.page ? "active" : "")
        }
        key={i}
        tabIndex={0}
        role="button"
        aria-label={I18n.t("page_number_of_search_results", { page_number: i })}
        onKeyDown={(e) => {
          if (e.keyCode === 13) {
            this.props.onChangePage(i, i === this.props.page);
          }
        }}
        onClick={this.props.onChangePage.bind(null, i, i === this.props.page)}
      >
        <div className="value">{i}</div>
      </div>
    );
  }
}
